import clsx from 'clsx';
import type { FC, MouseEvent, MutableRefObject } from 'react';
import { Picture } from '@ui';
import { createAddressString } from '@utils/address';
import icons from '@icons';
import { editAddressBlack, trashAddressBlack } from '@images';
import type { storeAddressT } from '@store/UserStore.type';

const {
  rocket: { purple: rocketPurpleFilled }
} = icons.Fill;

interface AddressDeliveryItemProps {
  item: storeAddressT;
  isActive: boolean;
  isOptionsOpen: boolean;
  popupRef: MutableRefObject<HTMLDivElement | null>;
  registerRef: (el: HTMLDivElement | null) => void;
  onSelect: (isShouldClose?: boolean) => void;
  onToggleOptions: (e: MouseEvent) => void;
  onEdit: (e: MouseEvent) => void;
  onDelete: (e: MouseEvent) => void;
}

const AddressDeliveryItem: FC<AddressDeliveryItemProps> = ({
  item,
  isActive,
  isOptionsOpen,
  popupRef,
  registerRef,
  onSelect,
  onToggleOptions,
  onEdit,
  onDelete
}) => (
  <div
    className={clsx('address-item', isActive && 'selected')}
    onClick={() => {
      onSelect();
    }}
    ref={registerRef}
  >
    <span className='block-address'>
      <div className='full-addres'>
        <div className='flex items-center gap-3'>
          <div className='deliveryType'>Курьер</div>
          {item?.isValidForExpress && (
            <div className='flex items-center gap-1 text-[#9645FF]'>
              <Picture icon={rocketPurpleFilled} width={16} height={16} />
              доставим от 30 мин
            </div>
          )}
        </div>

        <div className='deliveryAddress'>
          {createAddressString(item, true, false, true)}
        </div>
      </div>
    </span>
    <span className='block-address'>
      <div className='address-options'>
        <div className='icon-more' onClick={onToggleOptions}>
          ⋮
        </div>
        {isOptionsOpen && (
          <div className='address-options-popup' ref={popupRef}>
            <div className='address-options-menu'>
              <div className='address-options-item' onClick={onEdit}>
                <Picture
                  className='icon-edit'
                  icon={editAddressBlack}
                  height='20'
                  alt=''
                />
                <span>Редактировать</span>
              </div>
              <div className='address-options-item' onClick={onDelete}>
                <Picture
                  className='icon-remove'
                  icon={trashAddressBlack}
                  height='20'
                  alt=''
                />
                <span>Удалить адрес</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </span>
  </div>
);

export default AddressDeliveryItem;
